module.exports = "https://static-production.npmjs.com/c426a1116301d1fd178c51522484127a.png";